<script setup lang="ts">
const {
  variant = 'default',
  type = 'button',
  disabled = false,
  icon = { name: '', position: 'left' },
  loading = false,
  class: customClass = '',
  size = 'default'
} = defineProps<{
  variant?: 'default' | 'hero' | 'elegant' | 'error';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  icon?: { name: string; position: 'right' | 'left'; class?: string };
  loading?: boolean;
  class?: string;
  size?: 'default' | 'sm' | 'lg' | 'xl' | 'icon';
}>();

defineEmits<{ (e: 'click'): () => void }>();
</script>

<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="['btn', `btn-${variant}`, `size-${size}`, `icon-${icon.position}`, loading && 'loading', customClass]"
    @click="$emit('click')"
  >
    <span class="flex items-center gap-2">
      <Loader v-if="loading" class="h-3 w-3" />

      <Icon v-if="icon.name" :class="icon.class ?? 'h-6 w-6'" :icon-name="icon.name" />

      <slot />
    </span>
  </button>
</template>
